import { render } from "./AdvancedPanel.vue?vue&type=template&id=8821b4e8&ts=true"
import script from "./AdvancedPanel.vue?vue&type=script&lang=ts"
export * from "./AdvancedPanel.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__